import React from "react";
import Container from "components/Container/Container";

const Footer = () => (
  <footer>
    <Container>
      <p>
        Shop © 2020 <br /> Designed by Andrzej
      </p>
    </Container>
  </footer>
);

export default Footer;
